
(function (app, $) {
    var templateTag = '<div class="filterby__tag" data-filter-uid="{Uid}">' +
        '<div class="d-flex align-items-center" >' +
            '<span>{Libelle}</span>' +
            '<svg class="m-8 filterby__tag_remove" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">' +
                '<path fill="#333" fill-rule="evenodd" d="M.293.293c.39-.39 1.024-.39 1.414 0L7 5.585 12.293.293c.36-.36.928-.388 1.32-.083l.094.083c.39.39.39 1.024 0 1.414L8.415 7l5.292 5.293c.36.36.388.928.083 1.32l-.083.094c-.39.39-1.024.39-1.414 0L7 8.415l-5.293 5.292c-.36.36-.928.388-1.32.083l-.094-.083c-.39-.39-.39-1.024 0-1.414L5.585 7 .293 1.707C-.067 1.347-.095.78.21.387z" />' +
            '</svg>' +
        '</div >' +
    '</div >';
    var tabState = [
        {
            enableScroll: false,
            updateNavs: true
        },
        {
            enableScroll: false,
            updateNavs: true
        },
        {
            enableScroll: false,
            updateNavs: true
        },
    ];

    var HomeCollapse = function () {
        //collapse state element
        var _current = {
            open: {}, // the current collapse open
            show: {}, // the collpase show (only 3r or 5r)
            self: true, // if the base collapse is used
            active: false, // if a collapse is currently open
            lock: false // lock the state, no action nor modification can occure
        };

        //If $sefl is undefined, return the current collapse state. Otherwise, return a new collapse state element
        function Get($self) {
            if (!$self || _current.lock) {
                return _current;
            }

            var collapse = {
                open: $self.next(),
                show: {},
                self: true,
                active: true
            };

            if (window.matchMedia("(min-width: 1200px)").matches) {
                collapse.show = $self.nextAll('.collapse_5r:first');
                collapse.self = false;
            }
            else if (window.matchMedia("(min-width: 768px)").matches) {
                collapse.show = $self.nextAll('.collapse_3r:first');
                collapse.self = false;
            }

            return collapse;
        }

        function Hide() {
            if (_current.lock) {
                return;
            }

            if (_current.self) {
                _current.open.collapse('hide');
            }
            else {
                _current.show.collapse('hide');
                _current.lock = true; // no change until the collapse is hidden and reset is called (or kaboum !!!)
            }
            _current.active = false;
        }

        function Show($self) {
            if (_current.lock) {
                return;
            }

            Reset();
            _current = Get($self);

            if (_current.self) {
                _current.open.collapse('show');
            }
            else {
                _current.show.append(_current.open.children());
                _current.show.collapse('show');
            }
        }

        function Reset() {
            if (_current.self || _current.lock) {
                return;
            }

            _current.open.append(_current.show.children());
        }

        //event on hidden for the dynamic collapse
        $('.collapse_3r, .collapse_5r').on('hidden.bs.collapse', function () {
            if (_current.lock) {
                Reset();
                _current.lock = false; // you're free to go
            }
        });

        return {
            Get: Get,
            Hide: Hide,
            Show: Show
        };
    };
    var collapseState = HomeCollapse();

    function Home_LoadFilms(isReset, switchNav, callback) {
        isReset = isReset || false;
        switchNav = switchNav || false;
        callback = callback || function () { };
        var url = isReset ? app.routes.home.container : app.routes.home.films; 

        //need to reload all the navs
        var type = $('.home-content.active').data('timezone-type');

        if (!switchNav) {
            tabState = [
                {
                    enableScroll: false,
                    updateNavs: true
                },
                {
                    enableScroll: false,
                    updateNavs: true
                },
                {
                    enableScroll: false,
                    updateNavs: true
                },
            ];
        }

        $.get(url, { type: type })
            .done(function (data) {
                var selector = type !== undefined || type != null
                    ? '.home-content[data-timezone-type="' + type + '"]'
                    : '.home-content.active';

                if (isReset) {
                    $(selector).html(data);
                }
                else {
                    $(selector + ' .films-container').append(data);
                    if ($(selector + ' .stop-scroll').length === 0) {
                        tabState[type].enableScroll = true;
                    }
                    else {
                        tabState[type].enableScroll = false;
                    }
                }
                tabState[type].updateNavs = false;

                callback();
            })
            .fail(function (xhr, status, error) {
                console.error('Films loading error', status, error);
                callback();
            });
    }

    function GetCriteria(timezoneType) {
        timezoneType = timezoneType || 0;
        return {
            isWatchLater: $('#watchLater').is(':checked'),
            isFavorite: $('#favorites').is(':checked'),
            isNote: $('#notes').is(':checked'),
            isWatchable: $('#watchables').is(':checked'),
            displayScreening: $('#displayScreeningCriteria').val(),
            timezoneType: timezoneType,
            sortFullSchedule: $('.home-content.active .active-sort').data('val'),
            activeTag: $("#highlights .active").map(function () {
                return {
                    uid: this.dataset.lkelemKey,
                    category: this.dataset.filterCat,
                    value: this.dataset.filterVal
                }
            })
                .get()
                .concat(
                    $(".filter-input:checked").map(function () {
                        return {
                            uid: this.id,
                            category: this.dataset.filterCat,
                            value: this.value
                        }
                    }).get()
                )
        }
    }

    function SwapTileNote(_this) {
        var $tile = $(_this).closest('.film');
        $tile.find('img').toggleClass('d-none');
        $tile.find('.tile-action, .note-action, .note-box').toggleClass('d-none d-flex');
    }

    $(document).ready(function () {
        if ($('#page_home').length > 0) {
            var $home = $('#page_home');
            var onLoading = false;
            var timezoneType = $('.home-content.active').data('timezone-type');

            tabState[timezoneType].updateNavs = false;
            if (timezoneType != 0) {
                $('.hide-screening').attr('style', 'display:none !important');
            }

            //initialize swiper ( Slider accueil )
            if ($('.swiper-container .swiper-slide').length > 1) {
                var swiper = new Swiper('.swiper-container', {
                    parallax: true,
                    loop: true,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: true
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    }
                });

                //$('.swiper-container').hover(
                //    function () {
                //        swiper.autoplay.stop();
                //    },
                //    function () {
                //        swiper.autoplay.start();
                //    }
                //);
            }

            var tabWidth = $.map(
                $('#type_screening_tab li'),
                function (e) { return e.offsetWidth }
            ).reduce(function (acc, val) { return acc + val }, 0) + 5;
            $('#type_screening_tab').css('min-width', tabWidth + 'px'); //+ 5 permet d'assurer les décimals et les marges
            
            //search bar event
            $('#search_films').on('keyup', function (e) {
                if (e.which === 13) {
                    e.preventDefault();
                    $('#search_films_btn').trigger('click');
                }
            });
            $('#search_films_btn').on('click', function (e) {
                e.preventDefault();
                if ($('#search_films').val().length > 2 || $('#search_films').val().length == 0) {
                    $.post(app.routes.home.searchFilms, { query: $('#search_films').val() })
                        .done(function () {
                            Home_LoadFilms(true);
                        })
                        .fail(function (xhr, status, error) {
                            console.error('Films loading error', status, error);
                        });
                }

                return false;
            });

            //
            //Rapid Access
            //
            //rapid access filter
            $('#watchables').LinkedElement($('#watchables_h'));
            $('#watchLater').LinkedElement($('#watchLater_h'));
            $('#favorites').LinkedElement($('#favorites_h'));
            $('#notes').LinkedElement($('#notes_h'));
            $('#screening').LinkedElement($('#screening_h'));
            $('#highlights').LinkedElement($('#highlights_h'));

            //search trigger on rapid access element
            $('.switchC').on('click', function (e) {
                if (!e.echo) {
                    $(this).trigger('lnkElem.update');
                    $.post(app.routes.home.searchFilmsTags, GetCriteria())
                        .done(function () {
                            Home_LoadFilms(true);
                        })
                        .fail(function (xhr, status, error) {
                            console.error('Films loading error', status, error);
                        });
                }
            });

            //highlight click
            $('.dropdown-menu.lkelem-custom span').on('click', function (e) {
                e.preventDefault();
                $(this).toggleClass('active').trigger('lnkElem.update');

                $.post(app.routes.home.searchFilmsTags, GetCriteria())
                    .done(function () {
                        Home_LoadFilms(true);
                    })
                    .fail(function (xhr, status, error) {
                        console.error('Films loading error', status, error);
                    });

                return false;
            });

            //highlight active span calcul
            $('.dropdown-menu.lkelem-custom').on('lnkElem.updated', function () {
                var $this = $(this);
                var nbActive = $this.find('span.active').length;
                if (nbActive === 0) {
                    $this.prev().find('.count').addClass('d-none').text(nbActive);
                }
                else {
                    $this.prev().find('.count').text(nbActive).removeClass('d-none');
                }
            });

            //
            //Filters modal
            //
            //dropdown collpase management
            $('.filter_collapse').on('click', function (e) {
                e.preventDefault();
                if (collapseState.Get().lock) {
                    //stupid user, stop trying to break my code, you robot è_é
                    return;
                }

                var $this = $(this);

                if ($this.hasClass('open')) {
                    $this.removeClass('open');
                    collapseState.Hide();
                }
                else {
                    $this.parent().find('.filter_collapse.open').removeClass('open');
                    $this.parent().find('.filter_collapse.open .btn').addClass('hideBorder');

                    collapseState.Show($this);

                    $this.addClass('open');
                    $this.find('.btn').removeClass('hideBorder');
                }

                return false;
            });

            //tag click event
            $(".filter-input").on('click', function (e) {
                var count = $('#filters_table #cat_' + this.dataset.selectCat).find('.count')[0];
                var nbActive = count.dataset.nbSelected;

                if (this.checked) {
                    nbActive++;
                    $('#list_selected_tags').append(templateTag.replace('{Uid}', this.id).replace('{Libelle}', this.dataset.label));
                }
                else {
                    if (nbActive > 0) {
                        nbActive--;
                    }
                    $('#list_selected_tags [data-filter-uid=' + this.id + ']').remove();
                }

                if (nbActive == 0) {
                    count.classList.add('d-none');
                }

                count.innerHTML = nbActive;
                count.dataset.nbSelected = nbActive;

                if (nbActive > 0) {
                    count.classList.remove('d-none');
                }
            });

            //tag list remove click event
            $("#list_selected_tags").on('click', '.filterby__tag_remove', function (e) {
                var tag = $(this).closest('.filterby__tag');
                $('#' + tag.data('filter-uid')).click();
            });

            //filter reset button click event
            $('.filters-reset').on('click', function () {
                $(".filter-input:checked").prop('checked', false);
                $('#filters_table .btn-input').find('.count').each(function () {
                    this.innerHTML = 0;
                    this.dataset.nbSelected = 0;
                    this.classList.add('d-none');
                });
                $("#list_selected_tags").empty();

                $(".filter-item:checked").prop('checked', false);
                $(".filter-item.dropdown-menu .dropdown-item").removeClass('active');
                $(".filter-item.dropdown-menu .dropdown-item").trigger('lnkElem.updated');

                $.post(app.routes.home.searchFilmsTags, GetCriteria())
                    .done(function () {
                        Home_LoadFilms(true);
                    })
                    .fail(function (xhr, status, error) {
                        console.error('Films loading error', status, error);
                    });

                return false;
            });

            //filter submit button click event
            $('#filters_submit').on('click', function () {
                $.post(app.routes.home.searchFilmsTags, GetCriteria())
                    .done(function () {
                        Home_LoadFilms(true);
                    })
                    .fail(function (xhr, status, error) {
                        console.error('Films loading error', status, error);
                    });
            })

            $('.date-selector').on('change', function () {
                $('.' + this.dataset.dsTarget).addClass('d-none')
                    .filter('[data-ds-val=' + $(this).find('.active').data('item-val') + ']').removeClass('d-none').trigger('change');
            });

            $('.dropdown-select').on('click', '.dropdown-item:not(.active)', function () {
                var $this = $(this);
                $this.closest('.dropdown-select').find('.dropdown-select-val').text($this.text());
                $this.closest('.dropdown-menu').find('.dropdown-item').removeClass('active');
                $this.addClass('active').trigger('change');
            });

            $('.date-selector').on('change', function () {
                var $this = $(this);
                $('.' + $this.data('ds-target')).addClass('d-none').removeClass('d-flex');
                $('.' + $this.find('.active').data('ds-val')).addClass('d-flex').removeClass('d-none')
                    .find('.date-selector').trigger('change');
            });

            $('#release_date_year').trigger('change');

            //
            // Navs
            //
            //on navs displayed
            $('.home-navs a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                var self = this;
                if (self.dataset.timezoneType != 0) {
                    $('.hide-screening').attr('style', 'display:none !important');
                }
                else {
                    $('.hide-screening').removeAttr('style');
                }
                $.post(app.routes.home.searchFilmsTimezone, { type: self.dataset.timezoneType })
                    .done(function () {
                        if (tabState[self.dataset.timezoneType].updateNavs) {
                            Home_LoadFilms(true, true);
                        }
                    })
                    .fail(function (xhr, status, error) {
                        console.error('Films loading error', status, error);
                    });
            });

            //
            // Film search table
            //
            //films table scroll event (after more element have been clicked)
            $(window).on('scroll', function () {
                var type = $('.home-content.active').data('timezone-type');
                if (tabState[type].enableScroll && !onLoading) {
                    var scrollPos = $(window).height() + $(window).scrollTop();
                    if (scrollPos >= $home.offset().top + $home.height()) {
                        onLoading = true;
                        Home_LoadFilms(false, true, function () {
                            onLoading = false;
                        });
                    }
                }
            });

            //films table click events
            $home
                .on('click', '.sort-film-item', function () {
                    $.post(app.routes.home.searchFilmsSort, { column: this.dataset.val })
                        .done(function () {
                            Home_LoadFilms(true);
                        })
                        .fail(function (xhr, status, error) {
                            console.error('Films loading error', status, error);
                        });
                })
                .on('click', '.film-btn-watch-later', function () {
                    var $this = $(this);
                    $.post(app.routes.film.watchLater, { filmId: $this.closest('.film').data('film-id'), isWatchLater: !$this.hasClass('selected') })
                        .done(function () {
                            $this.toggleClass('selected');
                        })
                        .fail(function (xhr, status, error) {
                            console.error('Watch later update error', status, error);
                        });
                })
                .on('click', '.film-btn-favorite', function () {
                    var $this = $(this);
                    $.post(app.routes.film.favorite, { filmId: $this.closest('.film').data('film-id'), isFavorite: !$this.hasClass('favorite') })
                        .done(function () {
                            $this.toggleClass('favorite');
                        })
                        .fail(function (xhr, status, error) {
                            console.error('Fav update error', status, error);
                        });
                })
                .on('click', '.more_results', function () {
                    $(this).addClass("d-none").removeClass("btn-icon");
                    $('.home-content.active .films-container').css("margin-bottom", "30px");

                    Home_LoadFilms();
                    return false;
                });
        }

        if ($('#page_favorites, #page_notes').length > 0) {
            var $page = $('#page_favorites, #page_notes');

            //search bar event
            $('#search_films').on('keyup', function (e) {
                if (e.which === 13) {
                    e.preventDefault();
                    $('#search_films_btn').trigger('click');
                }
            });
            $('#search_films_btn').on('click', function (e) {
                e.preventDefault();
                if ($('#search_films').val().length > 2 || $('#search_films').val().length == 0) {
                    var data = {
                        "sortColumn": $('.home-content.active .active-sort').data('val'),
                        "criteria.query": $('#search_films').val(),
                        "criteria.isWatchLater": $('#watchLater').is(':checked'),
                        "criteria.isFavorite": $('#favorites').is(':checked'),
                        "criteria.isNote": $('#notes').is(':checked'),
                        "criteria.isWatchable": false,
                        "criteria.displayScreening": $('#displayScreeningCriteria').val()
                    };

                    $.get(app.routes.home.search, data)
                        .done(function (data) {
                            $page.html(data);
                        })
                        .fail(function (xhr, status, error) {
                            console.error('Films loading error', status, error);
                        });
                }

                return false;
            });

            //films table click events
            $page
                .on('click', '.sort-film-item', function () {
                    var data = {
                        "sortColumn": this.dataset.val,
                        "criteria.query": $('#search_films').val(),
                        "criteria.isWatchLater": $('#watchLater').is(':checked'),
                        "criteria.isFavorite": $('#favorites').is(':checked'),
                        "criteria.isNote": $('#notes').is(':checked'),
                        "criteria.isWatchable": false,
                        "criteria.displayScreening": $('#displayScreeningCriteria').val()
                    };

                    $.post(app.routes.home.searchFilmsSort, { column: this.dataset.val })
                        .done(function () {
                            $.get(app.routes.home.search, data)
                                .done(function (data) {
                                    console.log($page);
                                    $page.html(data);
                                })
                                .fail(function (xhr, status, error) {
                                    console.error('Films loading error', status, error);
                                });
                        })
                        .fail(function (xhr, status, error) {
                            console.error('Films loading error', status, error);
                        });
                })
                .on('click', '.film-btn-watch-later', function () {
                    var $this = $(this);
                    $.post(app.routes.film.watchLater, { filmId: $this.closest('.film').data('film-id'), isWatchLater: !$this.hasClass('selected') })
                    .done(function () {
                        $this.toggleClass('selected');
                    })
                    .fail(function (xhr, status, error) {
                        console.error('Watch later update error', status, error);
                    });
                })
                .on('click', '.film-btn-favorite', function () {
                    var $this = $(this);
                    $.post(app.routes.film.favorite, { filmId: $this.closest('.film').data('film-id'), isFavorite: !$this.hasClass('favorite') })
                        .done(function () {
                            $this.toggleClass('favorite');
                        })
                        .fail(function (xhr, status, error) {
                            console.error('Fav update error', status, error);
                        });
                })
                .on('click', '.send-fav-note', function () {
                    var data = {
                        "sortColumn": $('.home-content.active .active-sort').data('val'),
                        "criteria.query": $('#search_films').val(),
                        "criteria.isWatchLater": $('#watchLater').is(':checked'),
                        "criteria.isFavorite": $('#favorites').is(':checked'),
                        "criteria.isNote": $('#notes').is(':checked'),
                        "criteria.isWatchable": false,
                        "criteria.displayScreening": $('#displayScreeningCriteria').val()
                    };

                    $.post(app.routes.home.sendFavOrNote, data)
                        .done(function () {
                            alert(app.resources.alertemailsent);
                        })
                        .fail(function (xhr, status, error) {
                            alert(app.resources.alertemailerror);
                            console.error('Fav update error', status, error);
                        });
                });
        }

        if ($('#page_home, #page_favorites, #page_notes').length > 0) {
            var $pageAll = $('#page_home, #page_favorites, #page_notes');
            $pageAll
                .on('click', '.film-btn-note', function () {
                    SwapTileNote(this);
                })
                .on('click', '.note-save', function () {
                    SwapTileNote(this);

                    var $tile = $(this).closest('.film');
                    var filmId = $tile.data('film-id');
                    var note = $tile.find('.note-box textarea').val();

                    $.post(app.routes.film.note, { filmId: filmId, text: note })
                        .done(function () {
                            if (note) {
                                $tile.find('.film-btn-note').addClass('ischecked');
                            }
                            else {
                                $tile.find('.film-btn-note').removeClass('ischecked');
                            }
                        })
                        .fail(function (xhr, status, error) {
                            console.error('Note update error', status, error);
                        });
                })
                .on('click', '.note-close', function () {
                    SwapTileNote(this);
                });
        }

        if ($('#page_first_login').length > 0) {
            $('#timezone').select2({
                theme: 'bootstrap4',
                matcher: function (params, data) {
                    // If there are no search terms, return all of the data
                    if ($.trim(params.term) === '') {
                        return data;
                    }

                    if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) >= 0) {
                        return data;
                    }

                    return null;
                }
            }).on('select2:open', function (e) {
                $('#btn_timezone').prop('disabled', false);
            });


            $('#btn_timezone').on('click', function (e) {
                e.preventDefault();
                $.post(app.routes.home.saveTimezone, { timezone: $('#timezone').val() })
                    .done(function () {
                        window.location = app.routes.home.index;
                    })
                    .fail(function (xhr, status, error) {
                        console.error('Save timezone error', status, error);
                    });
            });
        }
    });
})(window.app = window.app || {}, jQuery);